import { Api, ApiResponse } from './api';
import { Token } from './token';

/**
 * UploadApi is used by the FileUploadWidget
 */
export class UploadApi {
    constructor(public readonly url: string, private readonly api: typeof Api) {}

    /**
     * @param input - the file input
     * @param path - the path to upload the file to, from the project root without leading and trailing slashes
     */
    async file<U = { filename: string }>(input: HTMLInputElement, path: string): Promise<ApiResponse<U>> {
        const data = new FormData();
        data.append('file', input.files.item(0));
        data.append('path', path);

        // does not use this.api.post() due to content-type form/multipart header added
        // by the browser is not compatible with content-type application/json
        const token = await this.api.request_token().then((t: Token) => t.token);
        let headers = new Headers({ Authorization: `Bearer ${token}` });
        headers = await this.api.add_csrf_header(headers, 'POST');
        const response = await fetch(`${this.url}/api/upload`, {
            body: data,
            method: 'post',
            headers,
        });
        const apiResponse = await response.json();
        if (apiResponse.statusCode.toString().search(/2\d\d/) === -1) {
            throw new Error(apiResponse.message);
        }
        return apiResponse;
    }
}
